<template>
  <div class="orderlist">
    orderlist
  </div>
</template>

<script>
export default {
  name: "orderlist",
  data() {
    return {

    };
  },
  methods: {
    
  },
};
</script>
<style lang="scss" scoped>
.orderlist {
	width: 100%;
	height: 100%;
	background: #fff;
}

</style>
